import environment from "common/environments";
import TagManager from "react-gtm-module";

export const initGoogleTagManager = () => {
  if (process.env.NODE_ENV !== "production") return;

  TagManager.dataLayer({
    dataLayer: {
      event: "user_data",
      user_id: undefined,
      workspace_id: undefined,
    },
  });
  TagManager.initialize({
    gtmId: environment.gtmId,
  });
};
